<template>
	<div>
      <h1 class="text-center mx-auto">Direkteinlagerungsliste</h1>
      <div class="card w-50 mx-auto">
        <div class="card-body" >
          <h4>Manuelle Einlagerung</h4>
          <b-input
              class="form-control mb-3 mx-auto"
              id="ean"
              ref="ean"
              placeholder="EAN"
              v-model="ean"
              @blur="ean = ean.toString().padStart(13, '0').trim()"
              @keyup.enter="$refs.conditions.focus()"
          ></b-input>
          <b-form-select
            id="conditions"
            ref="conditions"
            :options="conditions"
            v-model="condition"
            class="mb-3 mx-auto"
          >
          </b-form-select>
          <b-input
              class="form-control mb-3 mx-auto"
              id="quantity"
              type="number"
              ref="quantity"
              placeholder="Menge"
              v-model="quantity"
              @keyup.enter="$refs.vendors.focus()"
          ></b-input>
          <b-form-select
            class="mb-3 mx-auto"
            id="vendors"
            :options="vendors"
            v-model="vendor"
            ref="vendors"
          ></b-form-select>
					<b-input
							class="form-control mb-3 mx-auto"
							id="boxId"
							type="text"
							ref="boxId"
							placeholder="Kisten ID"
							v-model="boxId"
							@keyup.enter="$refs.comment.focus()"
					></b-input>
          <div class="d-flex mb-3">
	          <b-btn @click="$refs.quickCommentsModal.show()">
		          <i class="bi bi-star" ></i>
	          </b-btn>
            <b-input
                class=""
                id="comment"
                ref="comment"
                placeholder="Kommentar"
                v-model="comment"
                @keyup.enter="saveItem"
            ></b-input>
          </div>
          <div class="d-flex justify-content-end mb-3">
            <b-btn variant="primary" @click="saveItem()">Speichern</b-btn>
          </div>
        </div>
      </div>
      <div class="mx-auto w-75">
        <b-table class="mt-3 border"
        :items="directStockings"
        :fields="fields"
        hover
        >
          <template #cell(origin)="row">
            {{getOriginName(row.item?.origin)}}
          </template>
          <template #cell(vendorId)="row">
            {{getVendorName(row.item?.vendorId)}}
          </template>
          <template #cell(creatorUserId)="row">
            {{getUserShortname(row.item.creatorUserId)}}
          </template>
          <template #cell(completerUserId)="row">
            {{getUserShortname(row.item.completerUserId)}}
          </template>
					<template #cell(boxId)="row">
						{{row.item.boxId ? row.item.boxId : '-'}}
					</template>
          <template #cell(createdAt)="row">
            {{row.item.createdAt ? row.item.createdAt : '-'}}
          </template>
          <template #cell(completedAt)="row">
            {{row.item.completedAt ? row.item.completedAt : '-'}}
          </template>
          <template #cell(actions)="row">
            <b-button @click="deleteStocking(row.item)" variant="secondary"><i class="bi bi-trash"></i></b-button>
          </template>
        </b-table>
      </div>
		<b-modal
				id="quickCommentsModal"
				ref="quickCommentsModal"
				title="Quick Comments"
		>
      <div class="d-flex flex-wrap">
        <b-button
            v-for="(comment, index) in quickComments"
            :key="index"
            variant="outline-primary"
            class="m-1"
            @click="setComment(comment)"
        >
          {{ comment }}
        </b-button>
      </div>
    </b-modal>
	</div>
</template>
<script>
import { useBoxIdStore } from '../stores/BoxIdStore';
import { mapState } from 'pinia';

export default {
  props: ['passedDirectStockings'],
  data() {
    return {
      fields:
      [
        //Origin 1= Wareneingang, 2 = Retoure, 3 = Ausschussware
        {key: 'origin',                                     label:'Herkunft',           sortable: true},
        {key: 'materialId',                                 label:'MaterialID',         sortable: true},
        {key: 'material.ean',                               label:'Barcode',            sortable: true},
        {key: 'condition',                                  label:'Zustand',            sortable: true},
        {key: 'quantity',                                   label:'Menge',              sortable: true},
				{key: 'vendorId',                                   label:'Lieferant',          sortable: true},
				{key: 'boxId',                                   		label:'boxId',          		sortable: true},
        {key: 'createdAt',                                  label:'Erstellt am',        sortable: true},
        {key: 'creatorUserId',                              label:'Ersteller',          sortable: true},
        {key: 'completedAt',                                label:'Abgeschlossen',      sortable: true},
        {key: 'completerUserId',                            label:'Vervollständiger',   sortable: true},
        {key: 'actions',                                    label:'',                                 }
      ],
      users: [],
      directStockings: this.passedDirectStockings,
      vendors: [],
      vendor: '',
      ean: '',
      condition: 0,
      conditions: [
        { value: null, text: "Zustand auswählen" },
        { value: 1, text: "NEW" },
        { value: 2, text: "SH" },
        { value: 3, text: "SHY" },
				{ value: null, text: "------------", disabled: true },
				{ value: null, text: "Ausschussware", disabled: true },
      ],
      cint: [],
      quantity: 0,
      comment: '',
			boxId: '',
      showComments: false,
      quickComments: [
        "Geschenk",
        "Ladenpreis kleiner als 10€",
        "Für beschädigten Artikel bestellt",
        "Frist abgelaufen",
        "Lager 4",
        "Ausgeschlossen von Retouren",
        "Steht auf wartet",
        "Teuer"
      ]
    }
  },
	computed: {
		...mapState(useBoxIdStore, ['boxIdString']),
		isDamagedGoods() {
			return this.condition >= 6;
		},
	},
  methods : {
    getUserShortname(_userId){
      let user = this.users.find((user) =>{return user.id == _userId});
      if (user == null) {return '-'} else {return user.shortname}
    },
    getOriginName(originId){
      const origins = ['Wareneingang', 'Retoure', 'Ausschussware'];
      return origins[originId-1];
    },
    getVendorName(vendorId){
			if (!vendorId) {
				return '-';
			}
      let vendor = this.vendors.find((vendor) =>{return vendor.id == vendorId});
      if (vendor == null) {return '-'} else {return vendor.name}
    },
    deleteStocking(_stocking){
      axios.delete('/temporarydirectstockinglist/'+_stocking.id).then(() =>{
        this.directStockings = this.directStockings.filter((stocking) => {return stocking.id !== _stocking.id})});
    },
    setComment(comment){
      this.comment = comment;
	    this.$refs.quickCommentsModal.hide();
    },
    saveItem(){

      if(!this.itemIsValid()){
        return;
      }
      axios.get(`/material/temporarily_storable/${this.ean}/${this.condition}/warehouse/6`)
      .then((res => {
        console.log(res.data);
        if (res.data.state == 2) {
          alert("Artikel wurde nicht gefunden");
          return;
        } else if(res.data.state == 3) {
          alert("Artikel ist weltweit gesperrt");
          return;
        }else if(res.data.state == 4) {
          alert("Artikel wurde noch nie verkauft");
          return;
        }
				let conditionData = !this.isDamagedGoods ? this.condition : this.conditions.find(condition => condition.value == this.condition)?.text?.substring(0,1);

        axios.post('/temporarywarehouselist/directstocking/save', {
          ean: this.ean,
          condition: conditionData,
          quantity: this.quantity,
          vendorId: this.vendor,
          comment: this.comment,
					boxId: !this.isDamagedGoods ? this.boxId : null,
        }).then(res => {
          console.log(res);
          this.directStockings.push(res.data);
          this.$bvToast.toast(`Erfolgreich gespeichert`, {
            title: 'BootstrapVue Toast',
            autoHideDelay: 5000,
            variant: 'success'
          })
          this.resetInput();
          this.$refs.ean.focus()
        }).catch(err => {
          console.log(err);
          alert("Ein Fehler ist aufgetreten: " + err.response.data.message ?? err.message);
        });
      })).catch(err => {
        console.log(err);
        alert("Ein Fehler ist aufgetreten: " + err.response.data.message ?? err.message);
      });
    },
    itemIsValid(){
      if(this.ean === '') {
        alert("Bitte geben Sie einen Barcode ein");
        return false;
      } else if(this.condition === '' || this.condition === null) {
        alert("Bitte wählen Sie einen Zustand aus");
        return false;
      } else if(this.quantity === '' || this.quantity <= 0) {
        alert("Bitte geben Sie eine Menge ein");
        return false;
      } else if((this.vendor === '' || this.vendor === null) && !this.isDamagedGoods) {
				alert("Bitte wählen Sie einen Lieferanten aus");
				return false;
			}else if(this.boxId === '' && !this.isDamagedGoods) {
				alert("Bitte geben Sie eine Kisten ID ein");
				return false;
      } else {
        return true;
      }
    },

    resetInput(){
      this.ean = '';
      this.condition = this.conditions[0].value;
      this.quantity = 0;
      this.vendor = this.vendors[0].value;
      this.comment = '';
    },
  },
  created() {
    // console.log(this.directStockings);
    Promise.all([
      axios.get("/user/all"),
      axios.get("/vendor/all_names"),
      axios.get("/customitemnote/template/all")
    ]).then(([_users, _vendor, cint]) => {
      this.users = _users.data;
      this.vendors = _vendor.data;
			this.cint = cint.data.map(cint => {return {value: cint.id, text: cint.name, }});
			this.conditions = this.conditions.concat(this.cint);
			this.conditions = this.conditions.map((condition, id) => {
				condition.value !== null ? condition.value =  id : condition.value = null;
				return condition;
			});

      this.vendors = this.vendors.map((vendor) => {vendor.value = vendor.id; vendor.text = vendor.name; return vendor});
      this.vendors.unshift({value: null, text: 'Lieferant auswählen'});
      this.vendor = this.vendors[0].value;
      this.condition = this.conditions[0].value;
    });
  },
  mounted(){
	  if (this.boxIdString) this.boxId = this.boxIdString;
		this.$refs.ean.focus();
	}
}
</script>
